import CELL_DATA_TYPES from '../cell-types.config';
import { ACTIONS, CONNECTED_SOURCE_FOLDER_SYNC_STATUS } from '../const.config';

// Content Sources module configurations
export const LISTING_COLUMNS = [
  {
    id: 'folderName',
    label: 'Folder Name',
    width: '20%',
    align: 'left',
    dataKey: 'folderName',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'refTitle',
    label: 'Title/Series',
    width: '20%',
    align: 'left',
    dataKey: 'refTitle',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'status',
    label: 'Status',
    width: '8%',
    align: 'center',
    dataKey: 'status',
    sortable: true,
    type: CELL_DATA_TYPES.SOURCE_FOLDER_SYNC_STATUS,
    secondaryFields: [
      {
        dataKey: 'errorReason',
        type: CELL_DATA_TYPES.TEXT,
      },
    ],
  },
  {
    id: 'encodingStatus',
    label: 'Encoding Status',
    width: '8%',
    align: 'center',
    dataKey: 'encodingStatus',
    sortable: false,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'type',
    label: 'Type',
    width: '7%',
    align: 'center',
    dataKey: 'type',
    sortable: true,
    type: CELL_DATA_TYPES.CONTENT_SOURCE_TYPE,
  },
  {
    id: 'createdAt',
    label: 'Discovered At',
    width: '15%',
    align: 'right',
    dataKey: 'createdAt',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
  {
    id: 'lastSyncedAt',
    label: 'CMS Last Modified At',
    width: '15%',
    align: 'right',
    dataKey: 'lastSyncedAt',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];

export const LISTING_ACTIONS = [
  {
    action: ACTIONS.PREVIEW.value,
    label: ACTIONS.PREVIEW.label,
    conditional: (data) =>
      data.status !==
        CONNECTED_SOURCE_FOLDER_SYNC_STATUS.SYNCED_FROM_FTP.value &&
      data.status !== CONNECTED_SOURCE_FOLDER_SYNC_STATUS.SYNCING_WITH_S3.value,
  },
  {
    action: ACTIONS.PUSH_TO_CMS.value,
    label: ACTIONS.PUSH_TO_CMS.label,
    conditional: (data) =>
      data.status === CONNECTED_SOURCE_FOLDER_SYNC_STATUS.NEW.value,
  },
  {
    action: ACTIONS.RETRY.value,
    label: ACTIONS.RETRY.label,
    conditional: (data) =>
      data.status === CONNECTED_SOURCE_FOLDER_SYNC_STATUS.ERROR.value ||
      data.status === CONNECTED_SOURCE_FOLDER_SYNC_STATUS.MISSING_CSV.value ||
      data.status === CONNECTED_SOURCE_FOLDER_SYNC_STATUS.MISSING_ASSETS.value,
  },
];

export const PREVIEW_COLUMNS = [
  {
    id: 'Movie/Show Synopsis',
    label: 'Movie/Show Synopsis',
    dataKey: 'Movie/Show Synopsis',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'Movie/Show Sales Pitch',
    label: 'Movie/Show Sales Pitch',
    dataKey: 'Movie/Show Sales Pitch',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'Genre',
    label: 'Genre',
    dataKey: 'Genre',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'Festivals',
    label: 'Festivals',
    dataKey: 'Festivals',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'Cast',
    label: 'Cast',
    dataKey: 'Cast',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'Director(s)',
    label: 'Director(s)',
    dataKey: 'Director(s)',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'Writer(s)',
    label: 'Writer(s)',
    dataKey: 'Writer(s)',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'Producer(s)',
    label: 'Producer(s)',
    dataKey: 'Producer(s)',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'Movie Running Time',
    label: 'Movie Running Time',
    dataKey: 'Movie Running Time',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'Production Year',
    label: 'Production Year',
    dataKey: 'Production Year',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'Country of Origin',
    label: 'Country of Origin',
    dataKey: 'Country of Origin',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'Original Spoken Language',
    label: 'Original Spoken Language',
    dataKey: 'Original Spoken Language',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'Production Company',
    label: 'Production Company',
    dataKey: 'Production Company',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'Copyright',
    label: 'Copyright',
    dataKey: 'Copyright',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'Studio',
    label: 'Label',
    dataKey: 'Studio',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'IMDb ID',
    label: 'IMDb ID',
    dataKey: 'IMDb ID',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'IMDb Link',
    label: 'IMDb Link',
    dataKey: 'IMDb Link',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'Rating System',
    label: 'Rating System',
    dataKey: 'Rating System',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'Rating',
    label: 'Rating',
    dataKey: 'Rating',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'Voluntary Rating(s)',
    label: 'Voluntary Rating(s)',
    dataKey: 'Voluntary Rating(s)',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'Tag(s)',
    label: 'Tag(s)',
    dataKey: 'Tag(s)',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'Rating',
    label: 'Rating',
    dataKey: 'Rating',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'Rating',
    label: 'Rating',
    dataKey: 'Rating',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'Movie Chapters/Ad Breaks',
    label: 'Movie Chapters/Ad Breaks',
    dataKey: 'Movie Chapters/Ad Breaks',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'Movie Filename',
    label: 'Movie Filename',
    dataKey: 'Movie Filename',
    type: CELL_DATA_TYPES.DOWNLOADABLE_LINKS,
  },
  {
    id: 'Movie Audio Type',
    label: 'Movie Audio Type',
    dataKey: 'Movie Audio Type',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'Trailer',
    label: 'Trailer',
    dataKey: 'Trailer',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'Trailer Audio Type',
    label: 'Trailer Audio Type',
    dataKey: 'Trailer Audio Type',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'Trailer Filename',
    label: 'Trailer Filename',
    dataKey: 'Trailer Filename',
    type: CELL_DATA_TYPES.DOWNLOADABLE_LINKS,
  },
  {
    id: 'Movie Subtitles/Captions Languages',
    label: 'Movie Subtitles/Captions Languages',
    dataKey: 'Movie Subtitles/Captions Languages',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'Movie Subtitles/Captions Types',
    label: 'Movie Subtitles/Captions Types',
    dataKey: 'Movie Subtitles/Captions Types',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'Movie Subtitles/Captions Filenames',
    label: 'Movie Subtitles/Captions Filenames',
    dataKey: 'Movie Subtitles/Captions Filenames',
    type: CELL_DATA_TYPES.DOWNLOADABLE_LINKS,
  },
  {
    id: 'Key Art 2:3 Filename',
    label: 'Key Art 2:3 Filename',
    dataKey: 'Key Art 2:3 Filename',
    type: CELL_DATA_TYPES.DOWNLOADABLE_LINKS,
  },
  {
    id: 'Key Art 3:4 Filename',
    label: 'Key Art 3:4 Filename',
    dataKey: 'Key Art 3:4 Filename',
    type: CELL_DATA_TYPES.DOWNLOADABLE_LINKS,
  },
  {
    id: 'Key Art 16:9 Filename',
    label: 'Key Art 16:9 Filename',
    dataKey: 'Key Art 16:9 Filename',
    type: CELL_DATA_TYPES.DOWNLOADABLE_LINKS,
  },
  {
    id: 'Textless Hero 16:9 Filename',
    label: 'Textless Hero 16:9 Filename',
    dataKey: 'Textless Hero 16:9 Filename',
    type: CELL_DATA_TYPES.DOWNLOADABLE_LINKS,
  },
  {
    id: 'Other Key Art Filenames',
    label: 'Other Key Art Filenames',
    dataKey: 'Other Key Art Filenames',
    type: CELL_DATA_TYPES.DOWNLOADABLE_LINKS,
  },
  {
    id: 'Other Images Filenames',
    label: 'Other Images Filenames',
    dataKey: 'Other Images Filenames',
    type: CELL_DATA_TYPES.DOWNLOADABLE_LINKS,
  },
  {
    id: 'Episode SKU',
    label: 'Episode SKU',
    dataKey: 'Episode SKU',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'Episode Name',
    label: 'Episode Name',
    dataKey: 'Episode Name',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'Season Number',
    label: 'Season Number',
    dataKey: 'Season Number',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'Episode Number',
    label: 'Episode Number',
    dataKey: 'Episode Number',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'Episode Synopsis',
    label: 'Episode Synopsis',
    dataKey: 'Episode Synopsis',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'Episode Language',
    label: 'Episode Language',
    dataKey: 'Episode Language',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'Episode Chapters/Ad Breaks',
    label: 'Episode Chapters/Ad Breaks',
    dataKey: 'Episode Chapters/Ad Breaks',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'Episode Running Time',
    label: 'Episode Running Time',
    dataKey: 'Episode Running Time',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'Episode Filename',
    label: 'Episode Filename',
    dataKey: 'Episode Filename',
    type: CELL_DATA_TYPES.DOWNLOADABLE_LINKS,
  },
  {
    id: 'Episode Subtitles/Captions Filenames',
    label: 'Episode Subtitles/Captions Filenames',
    dataKey: 'Episode Subtitles/Captions Filenames',
    type: CELL_DATA_TYPES.DOWNLOADABLE_LINKS,
  },
  {
    id: 'Episode Subtitles/Captions Languages',
    label: 'Episode Subtitles/Captions Languages',
    dataKey: 'Episode Subtitles/Captions Languages',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'Episode Subtitles/Captions Type',
    label: 'Episode Subtitles/Captions Type',
    dataKey: 'Episode Subtitles/Captions Type',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'Episode Season Name',
    label: 'Episode Season Name',
    dataKey: 'Episode Season Name',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'availability',
    label: 'Availability',
    dataKey: 'availability',
    type: CELL_DATA_TYPES.TABLE,
  },
];

export const AVAILABILITY_LIST_COLUMNS = [
  {
    id: 'Avail Type(s)',
    label: 'Avail Type(s)',
    align: 'center',
    dataKey: 'Avail Type(s)',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'Avail Start',
    label: 'Avail Start',
    align: 'center',
    dataKey: 'Avail Start',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'Avail End',
    label: 'Avail End',
    align: 'center',
    dataKey: 'Avail End',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'Avail Countries Included',
    label: 'Avail Countries Included',
    align: 'center',
    dataKey: 'Avail Countries Included',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'Avail Countries Excluded',
    label: 'Avail Countries Excluded',
    align: 'center',
    dataKey: 'Avail Countries Excluded',
    type: CELL_DATA_TYPES.TEXT,
  },
];
